export default {
    name: 'orgsubscriptionservice',
    dependencies: ['xhrservice'],
    callable(xhr) {
        const SUB_PATH = '/org/sub/subscribe.json';
        const UNSUB_PATH = '/org/sub/unsubscribe.json';

        function handleResult(data) {
            return data.success ? Promise.resolve(data) : Promise.reject(data);
        }

        function subscribe(orgId, orgName, relation) {
            return xhr
                .getJson(buildUrl(SUB_PATH, orgId, orgName, relation))
                .then(handleResult);
        }

        function unsubscribe(orgId, relation) {
            return xhr
                .getJson(buildUrl(UNSUB_PATH, orgId, '', relation))
                .then(handleResult);
        }

        function buildUrl(path, orgId, orgName, relation) {
            const urlBuilder = new URL(path, document.baseURI);
            urlBuilder.searchParams.set('orgid', orgId);
            urlBuilder.searchParams.set('orgname', orgName);
            urlBuilder.searchParams.set('relation', relation);
            return urlBuilder.href;
        }

        return {
            subscribe,
            unsubscribe,
        };
    },
};



// WEBPACK FOOTER //
// ./services/orgsubscriptionservice.js